import React, { ReactElement } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import { useJobsiteOffboardContractorMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService';
import { CheckIcon } from 'components/icons';
import { OffboardJobsiteContractorModalProps } from './types';

export function OffboardJobsiteContractorModal(
  props: OffboardJobsiteContractorModalProps,
): ReactElement {
  const {
    isOpen,
    closeModal,
    onClosed,
    jobsiteContractorId,
    jobsiteName,
    contractorName,
    workersCount,
    refetchQueries,
  } = props;

  const [jobsiteOffboardContractor, { loading }] =
    useJobsiteOffboardContractorMutation({
      fetchPolicy: 'no-cache',
      onCompleted: () => {
        closeModal();
        AlertService.alert(
          'success',
          'Success',
          'Successfully removed workers from jobsite',
        );
      },
      onError: (responseError: ApolloError) => {
        AlertService.alert(
          'danger',
          'Something went wrong!',
          getGraphQLError(responseError),
        );
      },
      variables: { input: { jobsiteContractorId } },
      refetchQueries,
    });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="xs"
      title="Are you sure?"
      titleAlignment="center"
      text={`You are about to block all of ${contractorName}'s workers from being able to access ${jobsiteName}. This will affect ${workersCount} workers and will take effect immediately. Are you sure you want to proceed?`}
      textAlignment="center"
      onAction={jobsiteOffboardContractor}
      actionText="Offboard Workers"
      actionButtonTheme="danger"
      actionIcon={CheckIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
